import modelsData from '../data/models.json';

const imageModels = modelsData.imageModels || [];
const videoModels = modelsData.videoModels || [];
const allModels = [...imageModels, ...videoModels];

export function useModels() {
  const getModelsByCategory = (category) => allModels.filter(m => m.category === category);
  const getModelById = (id) => allModels.find(m => m.id === id);
  const getFreeModels = () => allModels.filter(m => m.free);
  const getPopularModels = () => allModels.filter(m => m.popular);

  return {
    imageModels,
    videoModels,
    models: allModels,
    loading: false,
    getModelsByCategory,
    getModelById,
    getFreeModels,
    getPopularModels,
  };
}
